import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'egi-comparison',
  templateUrl: './egi-comparison.component.html',
  styleUrls: ['./egi-comparison.component.css'],
})
export class EgiComparisonComponent implements OnInit {
  @Input() title: any;
  @Input() wEdifice: number;
  @Input() woEdifice: number;
  @Input() info: any;
  @Input() textSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() dollar: boolean = false;
  @Input() percent: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
